import React from "react";
import { Button, notification } from "antd";
import { injectIntl } from "react-intl";
import CacheBuster from "../../CacheBuster";

const CLAVE_NOTIFICACION = "bunkey.version.update";

/**
 * Avisa que hay una versión nueva publicada y ofrece recargar.
 *
 * KAN-44: se eligió avisar en vez de recargar solo — que era lo que hacía el
 * CacheBuster de 2020 — porque un reload automático corta una subida en curso o
 * un formulario a medio llenar. La notificación va con `duration: 0` para que
 * no se cierre sola, igual que el aviso de derechos por vencer.
 */
class VersionNotice extends React.Component {
  constructor(props) {
    super(props);
    this.avisar = this.avisar.bind(this);
  }

  componentWillUnmount() {
    notification.close(CLAVE_NOTIFICACION);
  }

  avisar({ latestVersion, refreshCacheAndReload }) {
    const { intl } = this.props;

    notification.info({
      key: CLAVE_NOTIFICACION,
      message: intl.formatMessage({ id: "app_version_update_title" }),
      description: intl.formatMessage(
        { id: "app_version_update_body" },
        { version: latestVersion }
      ),
      duration: 0,
      btn: (
        <Button
          type="primary"
          size="small"
          onClick={() => {
            notification.close(CLAVE_NOTIFICACION);
            refreshCacheAndReload();
          }}
        >
          {intl.formatMessage({ id: "app_version_update_action" })}
        </Button>
      )
    });
  }

  render() {
    return <CacheBuster onOutdated={this.avisar} />;
  }
}

export default injectIntl(VersionNotice);
